/**
 * Dependency imports
 */
import React, { useCallback } from 'react';
import { gsap } from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';
import { useGSAP } from '@gsap/react';

/**
 * Local imports
 */

/**
 * Default export
 */
export const useRender = (options: { smoothing: boolean }) => {
  const [rendered, setRendered] = React.useState(false);

  React.useEffect(() => {
    setRendered(true);
  }, []);

  // useGSAP(() => {
  //   if (!rendered) return;
  //   //   if (!rendered || !options.smoothing) return;

  //   //   // gsap.registerPlugin(ScrollTrigger, ScrollSmoother);
  //   gsap.registerPlugin(ScrollTrigger);

  //   ScrollTrigger.normalizeScroll(true);

  //   //   // ScrollSmoother.create({
  //   //   //   smooth: 1,
  //   //   //   effects: true,
  //   //   //   normalizeScroll: true,
  //   //   // });
  // }, [rendered]);
  // }, [rendered, options.smoothing]);

  const render = useCallback(
    (fixedContent: React.ReactNode, content: React.ReactNode) => (
      <div style={{ display: rendered ? 'block' : 'none' }}>
        {fixedContent}

        {/* <div id="smooth-wrapper">
          <div id="smooth-content"> */}
        {content}
        {/* </div>
        </div> */}
      </div>
    ),
    [rendered]
  );

  return render;
};